import { UtilService } from 'src/app/core/services/util/util.service';

import { Injectable, OnDestroy, DOCUMENT, inject } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SideNavService implements OnDestroy {
    private _document = inject<Document>(DOCUMENT);
    private _utils = inject(UtilService);

    private isSideNavOpenSub: BehaviorSubject<boolean>;
    private isSideNavOpen: boolean = false;
    private _subscriptions: Subscription[] = [];

    constructor() {
        this.isSideNavOpenSub = new BehaviorSubject<boolean>(false);
        this._subscriptions.push(
            this.getIsSideNavOpen().subscribe((isSideNavOpen: boolean) => {
                this.isSideNavOpen = isSideNavOpen;
            }),
        );
    }

    ngOnDestroy(): void {
        this._utils.unsubscribe(this._subscriptions);
        if (this.isSideNavOpenSub) this.isSideNavOpenSub.unsubscribe();
    }

    private _keyupSubscription: Subscription | null = null;
    private _offKeyupEvent() {
        this._keyupSubscription?.unsubscribe();
    }
    private _onKeyupEvent() {
        this._keyupSubscription = fromEvent(this._document, 'keyup').subscribe((event: Event) => {
            const keyboardEvent = event as KeyboardEvent;
            if (['Escape', 'Enter'].includes(keyboardEvent.key)) {
                this.setIsSideNavOpen(false);
            }
        });
        this._subscriptions.push(this._keyupSubscription);
    }
    public toggleSideNavOpen(): void {
        this.setIsSideNavOpen(!this.isSideNavOpen);
    }
    public getIsSideNavOpen(): Observable<boolean> {
        return this.isSideNavOpenSub.asObservable();
    }
    public getIsSideNav(): boolean {
        return this.isSideNavOpen;
    }
    public setIsSideNavOpen(isSideNavOpen: boolean): void {
        this.isSideNavOpenSub.next(isSideNavOpen);
        isSideNavOpen ? this._onKeyupEvent() : this._offKeyupEvent();
    }
}
